// extracted by mini-css-extract-plugin
module.exports = {"itemLink":"_19222e67","image":"_e0afb255"};